import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const VipTextOverlay = ({ content, rounded, compact = false, fullWidth }) => {
  const theme = useContext(ThemeContext);
  if (!content) return null;

  return (
    <>
      <div
        className={classNames('vip-overlay__container', {
          'variant-compact': compact,
          'variant-rounded': rounded,
        })}
      >
        {content}
      </div>
      <style jsx>{`
        .vip-overlay__container {
          display: block;
          padding: 6px 10px;
          text-align: center;
          font-size: 10px;
          width: fit-content;
          max-width: 230px;
          background-color: ${theme.colors.splatvariant.vip};
          color: ${theme.colors.primary};
          border-radius: 6px 0px 0px 6px;
        }
        .variant-compact {
          padding: 6px 12px;
          max-width: 230px;
        }
        .variant-rounded {
          border-radius: 4px;
          margin-bottom: 12px;
          text-align: left;
        }
      `}</style>
    </>
  );
};

VipTextOverlay.propTypes = {
  content: PropTypes.string,
};

export default VipTextOverlay;
